













import { Component, Vue, Prop } from 'vue-property-decorator';
import {代行ログイントークン型, 認証型} from '@/type/authentication/authentication';
import { tokenModule } from '@/store/authentication/authentication';
import { loginModule } from '@/store/authentication/login';
import api from '@/infrastructure/api/api';

@Component
export default class Manager extends Vue {
  private エラーリスト: string[] = [];
  @Prop()
  private token!: string;

  public mounted(): void {
    this.logon();
  }

  private async logon() {

    const 代行ログイントークン = new 代行ログイントークン型(this.$route.path);

    await tokenModule.マスターアカウントの認証をする(代行ログイントークン)
    .then((responese: any) => {
        loginModule.取得する();
        this.$router.push({ name: 'home' });
    })
    .catch((error: any) => {
        this.エラーリスト.push (error.data.message);
    });
  }
}
